export const getContrastingColour = <T>(
  hexColour: string,
  dark: T,
  light: T,
) => {
  const [r, g, b] = hexColour
    .replace('#', '')
    .match(/.{1,2}/g)
    ?.map((substr) => parseInt(substr, 16)) ?? [0, 0, 0]
  const luminance = (r * 0.299 + g * 0.587 + b * 0.144) / 255

  return luminance > 0.5 ? dark : light
}
